import { IRefusalReasonRepository } from './refusal-reason.repository.interface'
import { RefusalReasonsResponse } from './refusal-reason.types'

export class RefusalReasonService {
  constructor(private refusalReasonRepository: IRefusalReasonRepository) {}

  async getAll(): Promise<RefusalReasonsResponse[]> {
    return this.refusalReasonRepository.getAll()
  }
}
